<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details" *ngIf="!isAdd && !isViewMode && !isRefresh">
        <!-- <h4 class="personal-details-title">Batch Info List</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 15%;">Batch Id</th>
              <th style="width: 15%;">Batch Name</th>
              <th style="width: 15%;">Quantity</th>
              <th style="width: 15%;">Batch UOM</th>
              <th style="width: 15%;">Created Date</th>
              <th style="width: 15%;">Price</th>
              <th style="width: 25%;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let batch of batchInfoList | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count};let i = index">
              <th scope="col">{{batch.batchInfoId}}</th>
              <th scope="col">{{batch.batchName}}</th>
              <th scope="col">{{batch.batchQTY}}</th>
              <th scope="col">{{batch.batchUOM}}</th>
              <th scope="col">{{batch.createdDate | date}}</th>
              <th scope="col">{{batch.batchPrice}}</th>
              <th >
                <i class="bi bi-pencil-square" (click)="BatchInfoEdit(batch.batchInfoId)"></i>
                <i class="bi bi-eye-fill" (click)="getBatchInfo(batch.batchInfoId)"></i>
                <i class="bi bi-trash3" (click)="deleteBatch(batch.id)" data-toggle="modal" data-target="#deleteModal"></i>
              </th>
            </tr>
          </tbody>
        </table>
        <div class="pagination-block" *ngIf="batchInfoList.length != 0">
          <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="onTableDataChange($event)"
          >
          </pagination-controls>
        </div> -->

        <div class="header-block">
          <div class="header-title">
            <p>Batch Info List</p>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="search" (keyup.enter)="getBatchInfoByWildSearch()"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
              </form>
              <i class="bi bi-x-lg" (click)="clearSearch()" *ngIf="searchFilter" style="cursor: pointer;"></i>
              <i class="bi bi-search" (click)="getBatchInfoByWildSearch()" style="cursor: pointer;"></i>
            </div>
            <button (click)="openAdd()"><i class="bi bi-plus-lg"></i> Add</button>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 15%;">Batch Id</th>
              <th style="width: 15%;">Formula Name</th>
              <th style="width: 15%;">Batch Name</th>
              <th style="width: 10%;">Quantity</th>
              <th style="width: 10%;">Batch UOM</th>
              <th style="width: 15%;">Created Date</th>
              <th style="width: 10%;">Price</th>
              <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" (click)="onRowClick($event, batch.batchInfoId)" *ngFor="let batch of batchInfoList | paginate : {
            itemsPerPage: tableSize,
            currentPage: page,
            totalItems: count};let i = index">
            <p style="width: 15%;">{{batch.batchInfoId}}</p>
            <p style="width: 15%;">{{batch.formulaName}}</p>
            <p style="width: 15%;">{{batch.batchName}}</p>
            <p style="width: 10%;">{{batch.batchQTY}}</p>
            <p style="width: 10%;">{{batch.batchUOM}}</p>
            <p style="width: 15%;">{{batch.createdDate | date}}</p>
            <p style="width: 10%;">{{batch.batchPrice}}</p>
            <p class="action-buttons" style="width: 10%;padding-left: 25px;">
              <i *ngIf="batch.isRefresh" class="bi bi-arrow-clockwise" (click)="refreshBatch(batch.batchInfoId)" title="Refresh Batch"></i>
              <i *ngIf="actionControls.isModify" class="bi bi-pencil-square"
                (click)="BatchInfoEdit(batch.batchInfoId)"></i>
              <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getBatchInfo(batch.batchInfoId)"></i>
              <i *ngIf="actionControls.isDelete" class="bi bi-trash3" (click)="deleteBatch(batch.id)"
                data-toggle="modal" data-target="#deleteModal"></i>
            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && batchInfoList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>
        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>

      </div>

      <div class="add-batch-container" *ngIf="isAdd">
        <div class="add-batch-header">
          <div class="title-with-icon">
            <i class="bi bi-boxes" style="color: #0d6efd; font-size: 24px;"></i>
            <h2>{{isEdit ? 'Edit' : 'Add'}} Batch Info</h2>
          </div>
          <button class="btn-back" (click)="closeAdd()"><i class="bi bi-arrow-left"></i> Back</button>
        </div>

        <div class="form-grid">
          <div class="form-group full-width-field">
            <label>Formula Name <span class="required">*</span></label>
            <select class="form-control custom-select" [(ngModel)]="formulaName" (change)="batchNameSelected()">
              <option value="" disabled selected hidden>-- select name --</option>
              <option *ngFor="let product of productCompositioncList" [value]="product.productName">
                {{product.productName}}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Batch Name <span class="required">*</span> <i *ngIf="batchName != ''" data-toggle="modal"
                data-target="#productView" class="bi bi-info-circle-fill text-secondary"
                style="font-size: 14px;"></i></label>
            <input type="text" [(ngModel)]="batchName" class="form-control" placeholder="Enter formula name">

          </div>
          <div class="form-group">
            <label>Batch UOM <span class="required">*</span></label>
            <select class="form-control custom-select" [(ngModel)]="batchUOM" (change)="baseCalculate()">
              <option value="" disabled selected hidden>-- select uom --</option>
              <option *ngFor="let uom of supportedUOMObjList" [value]="uom.uomName">{{uom.uomName}}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Batch QTY <span class="required">*</span></label>
            <input type="text" [(ngModel)]="batchQty" class="form-control" placeholder="Enter quantity"
              (keyup)="baseCalculate()">
          </div>
          <div class="form-group">
            <label>Batch Price <span class="required">*</span></label>
            <input type="text" (keyup)="baseCalculate()" [(ngModel)]="batchPrice" class="form-control"
              placeholder="Enter price">
          </div>
        </div>

        <div class="action-row">
          <button class="btn-generate" (click)="generate()"><i class="bi bi-gear"></i> Generate</button>
          <div class="pagination-arrows">
            <button class="btn-arrow" (click)="backArrow()"><i class="bi bi-chevron-left"></i></button>
            <button class="btn-arrow" (click)="forwardArrow()"><i class="bi bi-chevron-right"></i></button>
          </div>
        </div>

        <div class="charges-section" *ngIf="batchQty != '' && batchPrice != '' && batchUOM != ''">
          <h3 class="section-title">Factory Charges</h3>
          <div class="charges-header">
            <div class="col-charge-name">Charge Name</div>
            <div class="col-base-charge">Base Charge</div>
            <div class="col-qty-group" *ngFor="let price of row[0]?.prices; let i = index; let last = last"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item">
                <span class="qty-label">
                  <input class="qty-input-inline" (input)="qtyChanged(0,i,$event)" (keyup)="qtyChanged(0,i,$event)" [(ngModel)]="price.qty" type="text">
                  <span (click)="select(i)">{{price.uom}}</span>
                </span>
                <i class="bi bi-dash-circle text-secondary action-icon" (click)="removeCol(i)"></i>
                <i class="bi bi-plus-circle-fill text-primary action-icon" *ngIf="last" (click)="addp()"></i>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of row; let r = index">
            <div class="col-charge-name">
              <input [(ngModel)]="charge.chargeName" type="text" class="form-control" placeholder="Charge Name">
              <i class="bi bi-trash text-danger delete-icon" *ngIf="row.length != 1 && r != 0"
                (click)="removeRow(r)"></i>
              <!-- Hidden spacing element when trash icon is absent to align fields properly -->
              <i class="bi bi-trash text-danger delete-icon" style="visibility: hidden;"
                *ngIf="row.length == 1 || r == 0"></i>
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.baseCharge">
            </div>
            <div class="col-qty-group" *ngFor="let price of charge.prices; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" [(ngModel)]="price.value" (keyup)="priceChanged(r,i,$event)" class="form-control"
                  [ngStyle]="{'border-color': price.individualCharge ? '#ffc107' : ''}">
                <input type="text" [(ngModel)]="price.totalValue" class="form-control">
              </div>
            </div>
          </div>

          <button class="btn-add-line" (click)="addrow()"><i class="bi bi-plus-circle"></i> Add Charge</button>

          <div class="total-row">
            <div class="total-label">Total Charge</div>
            <div class="col-qty-group total-value" *ngFor="let charge of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              {{charge.total | number:'1.0-2'}}
            </div>
          </div>
        </div>

        <div class="profits-section">
          <h3 class="section-title">Factory Profits</h3>
          <div class="charges-header">
            <div class="col-charge-name">Profit Name</div>
            <div class="col-base-charge">Percentage</div>
            <div class="col-qty-group" *ngFor="let tv of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{tv.qty}} {{tv.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of profitValue; let p = index">
            <div class="col-charge-name">
              <input type="text" class="form-control" [(ngModel)]="charge.profitName" placeholder="Profit Name">
              <!-- <i class="bi bi-trash text-danger delete-icon" (click)="removeProfit(p)"></i> -->
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.percentage">
            </div>
            <div class="col-qty-group" *ngFor="let profit of charge.profits; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" class="form-control" [value]="profit.value" readonly>
                <input type="text" class="form-control" [value]="profit.totalValue" readonly>
              </div>
            </div>
          </div>

          <div class="profit-actions">
            <!-- <button class="btn-add-line" (click)="addProfit()"><i class="bi bi-plus-circle"></i> Add Profit</button> -->
            <button class="btn-calculate" (click)="calculateProfitValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div>

          <div class="total-row" *ngIf="profitValue.length > 0">
            <div class="total-label">Total Profit</div>
            <div class="col-qty-group total-value" *ngFor="let profit of totalProfitValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              {{profit.total | number:'1.0-2'}}
            </div>
          </div>
        </div>

        <div class="charges-section" *ngIf="batchQty != '' && batchPrice != '' && batchUOM != ''">
          <h3 class="section-title">Extra Charges</h3>
          <div class="charges-header">
            <div class="col-charge-name">Charge Name</div>
            <div class="col-base-charge">Base Charge</div>
            <div class="col-qty-group" *ngFor="let price of (extraRow.length > 0 ? extraRow[0]?.prices : row[0]?.prices); let i = index; let last = last"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{(row && row[0]?.prices[i]?.qty) ? row[0].prices[i].qty : price.qty}} {{(row && row[0]?.prices[i]?.uom) ? row[0].prices[i].uom : price.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of extraRow; let r = index">
            <div class="col-charge-name">
              <input [(ngModel)]="charge.chargeName" type="text" class="form-control" placeholder="Charge Name">
              <i class="bi bi-trash text-danger delete-icon" (click)="removeExtraRow(r)"></i>
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.baseCharge">
            </div>
            <div class="col-qty-group" *ngFor="let price of charge.prices; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" [(ngModel)]="price.value" (keyup)="extraPriceChanged(r,i,$event)"
                  class="form-control" [ngStyle]="{'border-color': price.individualCharge ? '#ffc107' : ''}">
                <input type="text" [(ngModel)]="price.totalValue" class="form-control" readonly>
              </div>
            </div>
          </div>

          <div class="profit-actions">
            <button class="btn-add-line" (click)="addExtraRow()"><i class="bi bi-plus-circle"></i> Add Charge</button>
            <button class="btn-calculate" (click)="calculateExtraValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div>

          <div class="total-row" *ngIf="extraRow.length > 0">
            <div class="total-label">Total Extra Charge</div>
            <div class="col-qty-group total-value" *ngFor="let charge of totalExtraValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              {{charge.total | number:'1.0-2'}}
            </div>
          </div>
        </div>

        <div class="profits-section">
          <h3 class="section-title">Sales</h3>
          <div class="charges-header">
            <div class="col-charge-name">Profit Type</div>
            <div class="col-base-charge">Percentage</div>
            <div class="col-qty-group" *ngFor="let tv of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{tv.qty}} {{tv.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of salesChargeValue; let p = index">
            <div class="col-charge-name">
              <input type="text" class="form-control" [(ngModel)]="charge.chargeName" placeholder="Sale Name">
              <i class="bi bi-trash text-danger delete-icon" (click)="removeSalesCharge(p)"></i>
            </div>
            <div class="col-base-charge percentage-wrapper">
              <input type="text" class="form-control" [(ngModel)]="charge.percentage">
              <i class="bi sp-type-toggle"
                [ngClass]="charge.spType ? 'bi-plus-circle-fill text-success' : 'bi-dash-circle-fill text-danger'"
                (click)="charge.spType = !charge.spType; calculateSalesChargeValue()" title="Toggle Add/Minus"></i>
            </div>
            <div class="col-qty-group" *ngFor="let c of charge.charges; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" class="form-control" [value]="c.value" readonly>
                <input type="text" class="form-control" [value]="c.totalValue" readonly>
              </div>
            </div>
          </div>

          <div class="profit-actions">
            <button class="btn-add-line" (click)="addSalesCharge()"><i class="bi bi-plus-circle"></i> Add
              Profit Type</button>
            <button class="btn-calculate" (click)="calculateSalesChargeValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div>

          <!-- <div class="total-row" *ngIf="salesChargeValue.length > 0">
            <div class="total-label">Total Sales Charge</div>
            <div class="col-qty-group total-value" *ngFor="let tv of totalSalesChargeValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              {{tv.total | number:'1.0-2'}}
            </div>
          </div> -->
        </div>

        <div class="form-footer">
          <button class="btn-cancel" (click)="closeAdd()">Cancel</button>
          <button class="btn-submit" (click)="save()">Submit</button>
        </div>
      </div>


      <div class="add-batch-container" *ngIf="isRefresh">
        <div class="add-batch-header">
          <div class="title-with-icon">
            <i class="bi bi-arrow-clockwise" style="color: #0d6efd; font-size: 24px;"></i>
            <h2>Refresh Batch Info</h2>
          </div>
          <button class="btn-back" (click)="closeAdd()"><i class="bi bi-arrow-left"></i> Back</button>
        </div>

        <div class="form-grid">
          <div class="form-group full-width-field">
            <label>Formula Name <span class="required">*</span></label>
            <select class="form-control custom-select" [(ngModel)]="formulaName" (change)="batchNameSelected()"
              disabled>
              <option value="" disabled selected hidden>-- select name --</option>
              <option *ngFor="let product of productCompositioncList" [value]="product.productName">
                {{product.productName}}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Batch Name <span class="required">*</span> <i *ngIf="batchName != ''" data-toggle="modal"
                data-target="#productView" class="bi bi-info-circle-fill text-secondary"
                style="font-size: 14px;"></i></label>
            <input type="text" [(ngModel)]="batchName" class="form-control" placeholder="Enter formula name" readonly>
          </div>
          <div class="form-group">
            <label>Batch UOM <span class="required">*</span></label>
            <select class="form-control custom-select" [(ngModel)]="batchUOM" disabled>
              <option value="" disabled selected hidden>-- select uom --</option>
              <option *ngFor="let uom of supportedUOMObjList" [value]="uom.uomName">{{uom.uomName}}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Batch QTY <span class="required">*</span></label>
            <input type="text" [(ngModel)]="batchQty" class="form-control" placeholder="Enter quantity" readonly>
          </div>
          <div class="form-group">
            <label>Batch Price <span class="required">*</span></label>
            <input type="text" (keyup)="baseCalculate()" [(ngModel)]="batchPrice" class="form-control"
              placeholder="Enter price" readonly>
          </div>
          <div class="form-group">
            <label>Old Batch Price</label>
            <input type="text" [(ngModel)]="oldBatchPrice" class="form-control" readonly>
          </div>
        </div>

        <div class="action-row">
          <!-- <button class="btn-generate" (click)="generate()"><i class="bi bi-gear"></i> Generate</button> -->
          <div class="pagination-arrows">
            <button class="btn-arrow" (click)="backArrow()"><i class="bi bi-chevron-left"></i></button>
            <button class="btn-arrow" (click)="forwardArrow()"><i class="bi bi-chevron-right"></i></button>
          </div>
        </div>

        <div class="charges-section" *ngIf="batchQty != '' && batchPrice != '' && batchUOM != ''">
          <h3 class="section-title">Factory Charges</h3>
          <div class="charges-header">
            <div class="col-charge-name">Charge Name</div>
            <div class="col-base-charge">Base Charge</div>
            <div class="col-qty-group" *ngFor="let price of row[0]?.prices; let i = index; let last = last"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item">
                <span class="qty-label">
                  <input class="qty-input-inline" (keyup)="qtyChanged(0,i,$event)" [(ngModel)]="price.qty" type="text"
                    readonly>
                  {{price.uom}}
                </span>
                <!-- <i class="bi bi-dash-circle text-secondary action-icon" (click)="removeCol(i)"></i>
                <i class="bi bi-plus-circle-fill text-primary action-icon" *ngIf="last" (click)="addp()"></i> -->
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of row; let r = index">
            <div class="col-charge-name">
              <input [(ngModel)]="charge.chargeName" type="text" class="form-control" placeholder="Charge Name"
                readonly>
              <!-- <i class="bi bi-trash text-danger delete-icon" *ngIf="row.length != 1 && r != 0"
                (click)="removeRow(r)"></i> -->
              <!-- Hidden spacing element when trash icon is absent to align fields properly -->
              <!-- <i class="bi bi-trash text-danger delete-icon" style="visibility: hidden;"
                *ngIf="row.length == 1 || r == 0"></i> -->
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.baseCharge" readonly>
              <input type="text" class="form-control mt-1" *ngIf="batchPrice != oldBatchPrice"
                [value]="charge.oldBaseCharge !== undefined ? 'Old: ' + charge.oldBaseCharge : ''" readonly
                title="Old Base Charge"
                style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
            </div>
            <div class="col-qty-group" *ngFor="let price of charge.prices; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" [(ngModel)]="price.value" (keyup)="priceChanged(r,i,$event)" class="form-control"
                  readonly [ngStyle]="{'border-color': price.individualCharge ? '#ffc107' : ''}">
                <input type="text" [(ngModel)]="price.totalValue" class="form-control" readonly>
              </div>
              <div class="price-inputs" style="margin-top: 4px;" *ngIf="batchPrice != oldBatchPrice">
                <input type="text" class="form-control"
                  [value]="price.oldTotalValue !== undefined ? 'Old: ' + price.oldTotalValue : ''" readonly
                  title="Old Total Value"
                  style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
              </div>
            </div>
          </div>

          <!-- <button class="btn-add-line" (click)="addrow()"><i class="bi bi-plus-circle"></i> Add Charge</button> -->

          <div class="total-row">
            <div class="total-label">Total Charge</div>
            <div class="col-qty-group total-value" *ngFor="let charge of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span>{{charge.total | number:'1.0-2'}}</span>
                <span style="font-size: 12px; color: gray;" *ngIf="batchPrice != oldBatchPrice">Old: {{charge.oldTotal | number:'1.0-2'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="profits-section">
          <h3 class="section-title">Factory Profits</h3>
          <div class="charges-header">
            <div class="col-charge-name">Profit Name</div>
            <div class="col-base-charge">Percentage</div>
            <div class="col-qty-group" *ngFor="let tv of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{tv.qty}} {{tv.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of profitValue; let p = index">
            <div class="col-charge-name">
              <input type="text" class="form-control" [(ngModel)]="charge.profitName" placeholder="Profit Name"
                readonly>
              <!-- <i class="bi bi-trash text-danger delete-icon" (click)="removeProfit(p)"></i> -->
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.percentage" readonly>
            </div>
            <div class="col-qty-group" *ngFor="let profit of charge.profits; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" class="form-control" [value]="profit.value" readonly>
                <input type="text" class="form-control" [value]="profit.totalValue" readonly>
              </div>
              <div class="price-inputs" style="margin-top: 4px;" *ngIf="batchPrice != oldBatchPrice">
                <input type="text" class="form-control"
                  [value]="profit.oldTotalValue !== undefined ? 'Old: ' + profit.oldTotalValue : ''" readonly
                  title="Old Profit Total"
                  style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
              </div>
            </div>
          </div>

          <!-- <div class="profit-actions">
            <button class="btn-add-line" (click)="addProfit()"><i class="bi bi-plus-circle"></i> Add Profit</button>
            <button class="btn-calculate" (click)="calculateProfitValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div> -->

          <div class="total-row" *ngIf="profitValue.length > 0">
            <div class="total-label">Total Profit</div>
            <div class="col-qty-group total-value" *ngFor="let profit of totalProfitValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span>{{profit.total | number:'1.0-2'}}</span>
                <span style="font-size: 12px; color: gray;" *ngIf="batchPrice != oldBatchPrice">Old: {{profit.oldTotal | number:'1.0-2'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="charges-section" *ngIf="batchQty != '' && batchPrice != '' && batchUOM != ''">
          <h3 class="section-title">Extra Charges</h3>
          <div class="charges-header">
            <div class="col-charge-name">Charge Name</div>
            <div class="col-base-charge">Base Charge</div>
            <div class="col-qty-group" *ngFor="let price of (extraRow.length > 0 ? extraRow[0]?.prices : row[0]?.prices); let i = index; let last = last"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{(row && row[0]?.prices[i]?.qty) ? row[0].prices[i].qty : price.qty}} {{(row && row[0]?.prices[i]?.uom) ? row[0].prices[i].uom : price.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of extraRow; let r = index">
            <div class="col-charge-name">
              <input [(ngModel)]="charge.chargeName" type="text" class="form-control" placeholder="Charge Name"
                readonly>
              <!-- <i class="bi bi-trash text-danger delete-icon" (click)="removeExtraRow(r)"></i> -->
            </div>
            <div class="col-base-charge">
              <input type="text" class="form-control" [(ngModel)]="charge.baseCharge" readonly>
              <input type="text" class="form-control mt-1" *ngIf="batchPrice != oldBatchPrice"
                [value]="charge.oldBaseCharge !== undefined ? 'Old: ' + charge.oldBaseCharge : ''" readonly
                title="Old Base Charge"
                style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
            </div>
            <div class="col-qty-group" *ngFor="let price of charge.prices; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" [(ngModel)]="price.value" (keyup)="extraPriceChanged(r,i,$event)"
                  class="form-control" readonly [ngStyle]="{'border-color': price.individualCharge ? '#ffc107' : ''}">
                <input type="text" [(ngModel)]="price.totalValue" class="form-control" readonly>
              </div>
              <div class="price-inputs" style="margin-top: 4px;" *ngIf="batchPrice != oldBatchPrice">
                <input type="text" class="form-control"
                  [value]="price.oldTotalValue !== undefined ? 'Old: ' + price.oldTotalValue : ''" readonly
                  title="Old Total Value"
                  style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
              </div>
            </div>
          </div>

          <!-- <div class="profit-actions">
            <button class="btn-add-line" (click)="addExtraRow()"><i class="bi bi-plus-circle"></i> Add Charge</button>
            <button class="btn-calculate" (click)="calculateExtraValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div> -->

          <div class="total-row" *ngIf="extraRow.length > 0">
            <div class="total-label">Total Extra Charge</div>
            <div class="col-qty-group total-value" *ngFor="let charge of totalExtraValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span>{{charge.total | number:'1.0-2'}}</span>
                <span style="font-size: 12px; color: gray;" *ngIf="batchPrice != oldBatchPrice">Old: {{charge.oldTotal | number:'1.0-2'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="profits-section">
          <h3 class="section-title">Sales</h3>
          <div class="charges-header">
            <div class="col-charge-name">Profit Name</div>
            <div class="col-base-charge">Percentage</div>
            <div class="col-qty-group" *ngFor="let tv of totalValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="qty-header-item justify-center">
                <span class="qty-label">{{tv.qty}} {{tv.uom}}</span>
              </div>
            </div>
          </div>

          <div class="charge-row" *ngFor="let charge of salesChargeValue; let p = index">
            <div class="col-charge-name">
              <input type="text" class="form-control" [(ngModel)]="charge.chargeName" placeholder="Charge Name"
                readonly>
              <!-- <i class="bi bi-trash text-danger delete-icon" (click)="removeSalesCharge(p)"></i> -->
            </div>
            <div class="col-base-charge percentage-wrapper">
              <input type="text" class="form-control" [(ngModel)]="charge.percentage" readonly>
              <i class="bi sp-type-toggle disabled"
                [ngClass]="charge.spType ? 'bi-plus-circle-fill text-success' : 'bi-dash-circle-fill text-danger'"
                title="Add/Minus"></i>
            </div>
            <div class="col-qty-group" *ngFor="let c of charge.charges; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div class="price-inputs">
                <input type="text" class="form-control" [value]="c.value" readonly>
                <input type="text" class="form-control" [value]="c.totalValue" readonly>
              </div>
              <div class="price-inputs" style="margin-top: 4px;" *ngIf="batchPrice != oldBatchPrice">
                <input type="text" class="form-control"
                  [value]="c.oldTotalValue !== undefined ? 'Old: ' + c.oldTotalValue : ''" readonly
                  title="Old Sales Charge Total"
                  style="background-color: #f3f4f6; color: #6b7280; font-size: 12px; border-color: #e5e7eb;">
              </div>
            </div>
          </div>

          <!-- <div class="profit-actions">
            <button class="btn-add-line" (click)="addSalesCharge()"><i class="bi bi-plus-circle"></i> Add Profit
              Type</button>
            <button class="btn-calculate" (click)="calculateSalesChargeValue()"><i class="bi bi-calculator"></i>
              Calculate</button>
          </div> -->

          <!-- <div class="total-row" *ngIf="salesChargeValue.length > 0">
            <div class="total-label">Total Sales Charge</div>
            <div class="col-qty-group total-value" *ngFor="let tv of totalSalesChargeValue; let i = index"
              [style.display]="(i>=initialize && i <lastSized) ? 'flex' : 'none'">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span>{{tv.total | number:'1.0-2'}}</span>
                <span style="font-size: 12px; color: gray;" *ngIf="batchPrice != oldBatchPrice">Old: {{tv.oldTotal | number:'1.0-2'}}</span>
              </div>
            </div>
          </div> -->
        </div>

        <div class="form-footer" *ngIf="batchPrice != oldBatchPrice">
          <button class="btn-cancel" (click)="closeAdd()">Cancel</button>
          <button class="btn-submit" (click)="save()">Submit</button>
        </div>
      </div>

      <!-- New View Container -->
      <div class="view-container" id="view-batch-container" *ngIf="isViewMode">
        <div class="view-header">
          <div class="view-header-left">
            <div class="icon-box">
              <i class="bi bi-boxes text-primary"></i>
            </div>
            <div class="view-header-text">
              <h2>Batch Information</h2>
              <p>View batch details, charges and profit calculation</p>
            </div>
          </div>
          <button class="btn-back-view" (click)="closeView()"><i class="bi bi-arrow-left"></i> Back</button>
        </div>

        <div class="info-card">
          <div class="info-item full-width-field">
            <label>Formula Name</label>
            <p>{{viewData?.formulaName}}</p>
          </div>
          <div class="info-item">
            <label>Batch Name <i class="bi bi-info-circle-fill text-secondary"></i></label>
            <p>{{viewData?.batchName}}</p>
          </div>
          <div class="info-item">
            <label>Batch UOM</label>
            <p>{{viewData?.batchUOM}}</p>
          </div>
          <div class="info-item">
            <label>Batch QTY</label>
            <p>{{viewData?.batchQTY}}</p>
          </div>
          <div class="info-item">
            <label>Batch Price</label>
            <p>{{viewData?.batchPrice | number:'1.2-2'}}</p>
          </div>
        </div>

        <div class="card-section" *ngIf="viewData?.chargeDetail?.length > 0">
          <div class="section-header">
            <div class="icon-box-small">
              <i class="bi bi-cash-stack text-primary"></i>
            </div>
            <div class="section-header-text">
              <h3>Factory Charges</h3>
              <p>Breakdown of charges for this batch</p>
            </div>
            <div class="pagination-arrows" style="margin-left: auto;">
              <button class="btn-arrow" (click)="backArrow()"><i class="bi bi-chevron-left"></i></button>
              <button class="btn-arrow" (click)="forwardArrow()"><i class="bi bi-chevron-right"></i></button>
            </div>
          </div>

          <div class="table-responsive custom-table-wrapper">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th rowspan="2" style="vertical-align: middle;">#</th>
                  <th rowspan="2" style="vertical-align: middle;">Charge Name</th>
                  <th rowspan="2" style="vertical-align: middle;">Base Charge</th>
                  <th colspan="3" class="text-center group-header"
                    *ngFor="let col of viewData?.chargeColumns; let i = index"
                    [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">
                    {{col.qty}} {{col.uom}}
                  </th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of viewData?.chargeColumns; let i = index">
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Qty</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Value</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Total</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let charge of viewData?.chargeDetail; let i = index">
                  <td>{{i + 1}}</td>
                  <td>{{charge.chargeName}}</td>
                  <td>{{charge.chargePriceList[0]?.unitPrice}}</td>
                  <ng-container *ngFor="let price of charge.dynamicPrices; let j = index">
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.qty}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.unitPrice | number:'1.0-2'}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.subTotal | number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
                <tr>
                  <td colspan="3" class="total-cell" style="background: transparent;">Total Charge</td>
                  <ng-container *ngFor="let total of viewData?.chargeTotals; let j = index">
                    <td colspan="3" class="total-cell text-center"
                      [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">{{total |
                      number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-section" *ngIf="viewData?.profitDetail?.length > 0">
          <div class="section-header">
            <div class="icon-box-small">
              <i class="bi bi-bar-chart-fill text-primary"></i>
            </div>
            <div class="section-header-text">
              <h3>Factory Profits</h3>
              <p>Factory Profit details and calculated values</p>
            </div>
          </div>

          <div class="table-responsive custom-table-wrapper">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th rowspan="2" style="vertical-align: middle;">#</th>
                  <th rowspan="2" style="vertical-align: middle;">Profit Name</th>
                  <th rowspan="2" style="vertical-align: middle;">Percentage</th>
                  <th colspan="2" class="text-center group-header"
                    *ngFor="let col of viewData?.profitDetail[0]?.chargePriceList; let i = index"
                    [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">
                    {{col.qty}} {{col.uom}}
                  </th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of viewData?.profitDetail[0]?.chargePriceList; let i = index">
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Value</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Total</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let profit of viewData?.profitDetail; let i = index">
                  <td>{{i + 1}}</td>
                  <td>{{profit.chargeName}}</td>
                  <td>{{profit.profitPercentage}}%</td>
                  <ng-container *ngFor="let price of profit.chargePriceList; let j = index">
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.unitPrice | number:'1.0-2'}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.subTotal | number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
                <tr *ngIf="viewData?.profitTotals?.length > 0">
                  <td colspan="3" class="total-cell" style="background: transparent;">Total Profits</td>
                  <ng-container *ngFor="let total of viewData?.profitTotals; let j = index">
                    <td colspan="2" class="total-cell text-center"
                      [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">{{total |
                      number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-section" *ngIf="viewData?.extraDetail?.length > 0">
          <div class="section-header">
            <div class="icon-box-small">
              <i class="bi bi-cash-stack text-primary"></i>
            </div>
            <div class="section-header-text">
              <h3>Extra Charges</h3>
              <p>Breakdown of extra charges for this batch</p>
            </div>
          </div>

          <div class="table-responsive custom-table-wrapper">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th rowspan="2" style="vertical-align: middle;">#</th>
                  <th rowspan="2" style="vertical-align: middle;">Charge Name</th>
                  <th rowspan="2" style="vertical-align: middle;">Base Charge</th>
                  <th colspan="3" class="text-center group-header"
                    *ngFor="let col of viewData?.chargeColumns; let i = index"
                    [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">
                    {{col.qty}} {{col.uom}}
                  </th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of viewData?.chargeColumns; let i = index">
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Qty</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Value</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Total</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let charge of viewData?.extraDetail; let i = index">
                  <td>{{i + 1}}</td>
                  <td>{{charge.chargeName}}</td>
                  <td>{{charge.chargePriceList[0]?.unitPrice}}</td>
                  <ng-container *ngFor="let price of charge.dynamicPrices; let j = index">
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.qty}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.unitPrice | number:'1.0-2'}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.subTotal | number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
                <tr *ngIf="viewData?.extraTotals?.length > 0">
                  <td colspan="3" class="total-cell" style="background: transparent;">Total Extra Charge</td>
                  <ng-container *ngFor="let total of viewData?.extraTotals; let j = index">
                    <td colspan="3" class="total-cell text-center"
                      [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">{{total |
                      number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-section" *ngIf="viewData?.salesChargeDetail?.length > 0">
          <div class="section-header">
            <div class="icon-box-small">
              <i class="bi bi-bar-chart-fill text-primary"></i>
            </div>
            <div class="section-header-text">
              <h3>Sales</h3>
              <p>Sales charge details and calculated values</p>
            </div>
          </div>

          <div class="table-responsive custom-table-wrapper">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th rowspan="2" style="vertical-align: middle;">#</th>
                  <th rowspan="2" style="vertical-align: middle;">Charge Name</th>
                  <th rowspan="2" style="vertical-align: middle;">Percentage</th>
                  <th colspan="2" class="text-center group-header"
                    *ngFor="let col of viewData?.salesChargeDetail[0]?.chargePriceList; let i = index"
                    [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">
                    {{col.qty}} {{col.uom}}
                  </th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of viewData?.salesChargeDetail[0]?.chargePriceList; let i = index">
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Value</th>
                    <th class="text-center sub-th"
                      [style.display]="(i>=initialize && i <lastSized) ? 'table-cell' : 'none'">Total</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let charge of viewData?.salesChargeDetail; let i = index">
                  <td>{{i + 1}}</td>
                  <td>{{charge.chargeName}}</td>
                  <td>{{charge.profitPercentage}}%</td>
                  <ng-container *ngFor="let price of charge.chargePriceList; let j = index">
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.unitPrice | number:'1.0-2'}}</td>
                    <td class="text-center" [style.display]="(j>=initialize && j <lastSized) ? 'table-cell' : 'none'">
                      {{price.subTotal | number:'1.0-2'}}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="footer-card">
          <div class="footer-info">
            <i class="bi bi-check-circle-fill text-success" style="font-size: 18px;"></i>
            <span>This batch information is generated based on the selected product composition and configured charges.</span>
          </div>
          <div class="footer-actions">
            <button class="btn btn-outline-secondary btn-excel" (click)="exportExcel()" style="background: white; border: 1px solid #d1d5db; color: #374151; display: flex; align-items: center; gap: 6px;"><i class="bi bi-file-earmark-excel"></i> Excel</button>
            <button class="btn btn-primary btn-download" (click)="download()" style="display: flex; align-items: center; gap: 6px;"><i class="bi bi-download"></i> Download</button>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalView1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Details
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-md-6 col-md-lg-6">
            <input type="text" [(ngModel)]="priceInput" class="form-control" placeholder="">
          </div>
          <div class="col-md-6 col-md-lg-6">
            <select class="form-control" [(ngModel)]="uomInput">
              <option value="" disabled selected hidden>-- select uom --</option>
              <option *ngFor="let uom of uomData" [value]="uom.uomName">{{uom.uomName}}</option>
            </select>
          </div>
        </div>


        <div class="modal-footer">
          <button type="button" id="closeModalButton4" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" id="closeModalButton" class="btn btn-primary" (click)="addc()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this batch info?</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteBatchInfo()" class="btn btn-primary" data-dismiss="modal">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>